"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HOTRO_URL = exports.STATIC_FILE_URL = exports.NOTI_URL = exports.LOGIN_URL = exports.AFWBBS_URL = exports.SOTONG_URL = exports.LOG_API_URL = exports.ADBALLOON_URL = exports.ITEMS_URL = exports.ITEM_URL = exports.POINT_URL = exports.NOTE_URL = exports.VOD_URL = exports.PLAY_URL = exports.BJ_AFREECA_URL = exports.GATEWAY_API_URL = exports.API_M_AFREECA_URL = exports.BJ_PROFILE_URL = exports.STIMG_URL = exports.RES_URL = exports.DOMAIN = void 0;
exports.DOMAIN = "onlive.vn";
exports.RES_URL = "//res.onlive.vn";
exports.STIMG_URL = "//stimg.onlive.vn";
exports.BJ_PROFILE_URL = "//profile.img.onlive.vn";
exports.API_M_AFREECA_URL = "//api.m.onlive.vn";
exports.GATEWAY_API_URL = "//afevent.onlive.vn";
exports.BJ_AFREECA_URL = "//streamer.onlive.vn";
exports.PLAY_URL = "https://play.onlive.vn";
exports.VOD_URL = "https://vod.onlive.vn";
exports.NOTE_URL = "//note.onlive.vn";
exports.POINT_URL = "https://point.onlive.vn";
exports.ITEM_URL = "https://item.onlive.vn";
exports.ITEMS_URL = "https://items.onlive.vn";
exports.ADBALLOON_URL = "https://adballoon.onlive.vn";
exports.LOG_API_URL = "//eventapi.onlive.vn";
exports.SOTONG_URL = "//sotong.onlive.vn";
exports.AFWBBS_URL = "//afwbbs1.onlive.vn";
exports.LOGIN_URL = "https://login.onlive.vn";
exports.NOTI_URL = "//noti.onlive.vn";
exports.STATIC_FILE_URL = "https://static.file.onlive.vn";
exports.HOTRO_URL = "https://hotro.onlive.vn";